import { mergeAttributes, Node } from '@tiptap/react';

import {
  parseProjectsStarterBundleItems,
  PROJECTS_STARTER_BUNDLE_NODE_NAME,
  renderProjectsStarterBundleHtml,
  type ProjectsComposerStarterBundle,
} from '../../../data';

export const ProjectsStarterBundleNode = Node.create({
  name: PROJECTS_STARTER_BUNDLE_NODE_NAME,
  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,
  draggable: false,

  addAttributes() {
    return {
      starterId: {
        default: '',
        rendered: false,
        parseHTML: (element: HTMLElement) => element.dataset.starterId ?? '',
      },
      leadIn: {
        default: '',
        rendered: false,
        parseHTML: (element: HTMLElement) => element.dataset.leadIn ?? '',
      },
      items: {
        default: [],
        rendered: false,
        parseHTML: (element: HTMLElement) =>
          parseProjectsStarterBundleItems(element.dataset.items),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'span[data-projects-starter-bundle]' }];
  },

  renderHTML({ HTMLAttributes, node }) {
    const [, dataAttrs, text] = renderProjectsStarterBundleHtml(
      node.attrs as ProjectsComposerStarterBundle
    );
    return ['span', mergeAttributes(HTMLAttributes, dataAttrs), text];
  },
});
